module.exports = __webpack_public_path__ + "img/a2dc96d.jpg";